import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";
import { AiFillApple } from "react-icons/ai";
import { CONTACT_EMAIL, RESOURCE_LINKS } from "@/components/landing/data";
import { Lines, useLanding } from "@/components/landing/i18n";
import ContactEmail from "@/components/landing/ContactEmail";

const Footer = () => {
  const { language } = useI18n();
  const { isLoading, downloadLatest } = useDownload();
  const { t } = useLanding();
  const f = t.footer;

  return (
    <>
      {/* Final call to action */}
      <section className="final pad">
        <div className="wrap" style={{ position: 'relative' }}>
          <img className="icon-big r" src="/landing/estha-icon-128.png" alt="" />
          <h2 className="h2 r"><Lines text={t.final.title} /></h2>
          <div className="cta-row r">
            <Button
              size="lg"
              className="text-base px-8 bg-[#1E88C8] hover:bg-[#1670A8] text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
              onClick={downloadLatest}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 animate-spin" />
                  {language === 'en' ? 'Loading...' : '加载中...'}
                </>
              ) : (
                <>
                  <AiFillApple className="mr-1" />
                  {language === 'en' ? 'Download Estha for Mac' : '下载 Estha for Mac'}
                </>
              )}
            </Button>
          </div>
          <div className="reqs r">
            <span>{t.final.reqs}</span>
          </div>
        </div>
      </section>

      <footer>
        <div className="wrap">
          <div className="foot">
            <div>
              <a className="brand" href="#top">
                <img src="/landing/estha-icon-128.png" alt="Estha" />
                <b>Estha</b>
              </a>
              <p className="tag">
                {f.tagline}
              </p>
            </div>
            <div>
              <h5>{f.product}</h5>
              <ul>
                <li><a href="#chat">Chat Apps</a></li>
                <li><a href="#build">{f.createApp}</a></li>
                <li><a href="#agentic">Agentic Apps</a></li>
                <li><a href="#pricing">{f.pricing}</a></li>
              </ul>
            </div>
            <div>
              <h5>{f.orgs}</h5>
              <ul>
                <li><a href="#org">My Org</a></li>
                <li><ContactEmail up>{CONTACT_EMAIL}</ContactEmail></li>
              </ul>
            </div>
            <div>
              <h5>{f.company}</h5>
              <ul>
                <li><a href="https://estha.ai">estha.ai</a></li>
                <li><a href="https://estha.ai/privacypolicy/" target="_blank" rel="noopener noreferrer">{f.privacy}</a></li>
                <li><a href="https://estha.ai/tos/" target="_blank" rel="noopener noreferrer">{f.terms}</a></li>
                {(Object.keys(RESOURCE_LINKS) as (keyof typeof RESOURCE_LINKS)[])
                  .filter((k) => RESOURCE_LINKS[k])
                  .map((k) => (
                    <li key={k}><a href={RESOURCE_LINKS[k]} target="_blank" rel="noopener noreferrer">{f[k]}</a></li>
                  ))}
              </ul>
            </div>
          </div>
          <div className="legal">
            <span>{f.rights}</span>
            <span>mac.estha.ai · estha.ai</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
